import { ref } from 'vue'
// 默认先这两种
type LanguageType = 'CN,zh-Hans' | 'US,en'
export default function useLanguage() {
  // 获取浏览器的语言和地区
  const browserLanguage = navigator.language
  const language_local = localStorage.getItem('locale') as LanguageType
  const currentHost = window.location.hostname
  // 当前语言
  const _language = ref<LanguageType>(language_local)

  // 国内只能访问国内版本
  if (currentHost.includes('.cn') || currentHost.includes('zaohaowu.com')) {
    _language.value = 'CN,zh-Hans'
  } else {
    _language.value = language_local
      ? language_local
      : browserLanguage.includes('zh')
        ? 'CN,zh-Hans'
        : 'US,en'
  }
  return {
    locale: _language.value,
    isEnglish: _language.value === 'US,en'
  }
}
